<template>
  <EmdPanel>
    <EmdPanelSection :title="$t('managing-partners')">
      <jade-button
        variant="neutral-subtle"
        size="medium"
        icon="plus"
        @click="$emit('add')"
      >
        {{ $t('add-managing-partner') }}
      </jade-button>
      <EmdCollapse
        :key="index"
        v-for="(partner, index) in managing_partners"
        :title="partner.name || $t('managing-partner', { number: index + 1 })"
      >
        <template #content>
          <managing-partner-item :recipient="partner" />
        </template>
        <template #icon>
          <jade-icon-button
            variant="danger-ghost"
            size="small"
            icon="trash"
            @click="$emit('remove', index)"
          >
          </jade-icon-button>
        </template>
      </EmdCollapse>
    </EmdPanelSection>
  </EmdPanel>
</template>
<script>
import JadeButton from '@jade/JadeButton/index.vue'
import JadeIconButton from '@jade/JadeIconButton/index.vue'
import {
  EmdPanel,
  EmdCollapse,
  EmdPanelSection
} from 'emerald-vue/src/components'

import ManagingPartnerItem from './ManagingPartner'

export default {
  name: 'ManagingPartners',
  components: {
    JadeButton,
    JadeIconButton,
    EmdPanel,
    EmdPanelSection,
    EmdCollapse,
    ManagingPartnerItem
  },
  props: {
    managing_partners: {
      type: Array,
      required: true
    }
  }
}
</script>

<i18n>
  {
    "pt-BR": {
      "managing-partners": "Sócios",
      "managing-partner": "Sócio {number}",
      "add-managing-partner": "Adicionar sócio",
      "remove-managing-partner": "Remover sócio"
    },
    "en-US": {
      "managing-partners": "Managing partners",
      "managing-partner": "Managing partner {number}",
      "add-managing-partner": "Add managing partner",
      "remove-managing-partner": "Remove managing partner"
    }
  }
</i18n>
